import { toAbsoluteUrl } from '@/utils/Assets';
import { KeenIcon } from '@/components';
import { Container, StickyDetailBar } from '@/components/container';
import { GeneralProfileHero } from '@/partials/heros';
import { Navbar, NavbarActions, NavbarDropdown } from '@/partials/navbar';
import { ContactDetailsMenu } from './ContactDetailsMenu';
import { useConfirmationModal, useHiddenModules } from '@/hooks';
import { ConfirmationModal } from '@/components/modal';
import { Navigate, useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState, Fragment } from 'react';
import { ContactMatters, contactMatter, tableData } from '@/pages/account/members/team-info/blocks';
import { toast } from 'sonner';
import contactService from '@/services/contact/contactService';
import invoiceService from '@/services/billing/invoice/invoiceService';
import {
  AboutTab,
  MattersTab,
  ContactFiles,
  ContactMessagesTab,
  InvoiceContactTab,
  ExpensesContactTab,
  FlatFeesContactTab,
  ContactDocumentSignature,
  // ItemsTab,
} from '@/components/contact';
import { useAuthContext } from '@/auth';
import { ContactMatterBillingSummary } from '@/components/invoice';
import { AilaSummaryPanel } from '@/components/aila';
import { RemindersTab } from '@/components/reminders';
// activity log
import activityService from '@/services/activities/activityService';
import { ActivityTab } from '@/components/activityLog';
import { cn } from '@/lib/utils';
import { useAbility } from '@/providers/';
import { Can } from '@casl/react';

const ContactsDetail = () => {
  const { id } = useParams();
  const contactId = id;
  const { auth } = useAuthContext();
  const { ability } = useAbility();
  // const member = tableData.find((item) => item.id.toString() === id);
  // const fullName = member?.firstName + ' ' + member?.lastName;
  console.log(auth.user)
  const [contactData, setContactData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false)
  const { isOpen, actionId, openModal, closeModal } = useConfirmationModal();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [contactPaymentHistory, setContactPaymentHistory] = useState(0.00)
  const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false)
  // activty log
  const [activityData, setActivityData] = useState([]);
  const canViewActivity = ability.can('view', 'activity');
  const canAccessFlatFees = ability.can('handle', 'flat-fees');
  const canAccessExpense = ability.can('handle', 'expense');
  const canAccessInvoice = ability.can('access', 'invoice');
  // A firm that switched Billing off gets no billing tabs or summary here (OL-135).
  const { isHidden } = useHiddenModules();
  const billingHidden = isHidden('billing');
  const BILLING_TABS = ['Invoices', 'Expenses', 'Flat Fees'];
  const canAccessMatter = ability.can('access', 'matter');
  const canAccessContact = ability.can('access', 'contact');
  const canHandleContact = ability.can('handle', 'contact');
  const canAccessReminder = ability.can('access', 'reminder');

  const fetchContactPaymentHistory = async () => {
    setPaymentHistoryLoading(true)
    try {
      const payload = {
        model_id: contactId,
        model_type: 'contact'
      }
      const { data, status } = await invoiceService.getInvoicePaymentDetails(payload);
      if (status) {
        console.log('data', data)
        setContactPaymentHistory(data)
      }
    } catch (error) {
      console.error('Error', error)
      toast.error('Failed to fetch Contact Payment History.', {
        description: 'An error occurred while fetching contact payment history. Please try again later.',

      });
    } finally {
      setPaymentHistoryLoading(false)
    }
  }

  const getActivities = async () => {
    // setDataLoading(true)
    try {
      const payload = {
        model_id: contactId,
        model_type: 'contact'
      }
      // const { data, status } = await activityService.getActivity(contactId);
      const { data, status } = await activityService.getActivity(payload);
      if (status) {
        setActivityData(data);
      }
    } catch (error) {
      console.error('Error', error)
      toast.error('Oops! Something went wrong.', {
        description: 'An error occurred while fetching Invoice Activities. Please try again in a moment.',

      });
    } finally {
      // setDataLoading(false)
    }
  }

  const profileTabs = [
    { text: 'About', icon: 'profile-circle', comingSoon: false, disabled: true },
    { text: 'Matters', icon: 'book-square', comingSoon: false, disabled: canAccessMatter },
    { text: 'Messages', icon: 'messages', comingSoon: (contactData.allow_secure_messaging != 1 || !ability.can('handle', 'contact')), disabled: true },
    { text: 'Invoices', icon: 'cheque', comingSoon: false, disabled: canAccessInvoice },
    { text: 'Expenses', icon: 'dollar', comingSoon: false, disabled: canAccessExpense },
    { text: 'Flat Fees', icon: 'tag', comingSoon: false, disabled: canAccessFlatFees },
    // {text: 'Items', icon: 'scroll', comingSoon: true, disabled: false},
    { text: 'Files', icon: 'files', comingSoon: false, disabled: true },
    // Shown as "Tasks" (OL-210); the key stays Reminders so ?tab=Reminders links keep working.
    { text: 'Reminders', label: 'Tasks', icon: 'notification-bing', comingSoon: false, disabled: canAccessReminder },
    { text: 'Document Signature', icon: 'message-edit', comingSoon: false, disabled: canHandleContact }
  ].filter((tab) => !(billingHidden && BILLING_TABS.includes(tab.text)));

  const tabComponents = {
    About: <AboutTab contactData={contactData} loading={dataLoading} />,
    Matters: <MattersTab contactID={contactId} contactData={contactData} />,
    Messages: <ContactMessagesTab contactData={contactData} contactID={contactId} />,
    Invoices: <InvoiceContactTab
      matterID={contactData.matter_id}
      contactID={contactId}
      contactData={contactData}
      fetchPaymentHistory={fetchContactPaymentHistory}
      fetchActivity={getActivities}
      activityPerm={canViewActivity}
    />,
    Expenses: <ExpensesContactTab contactID={contactId} />,
    "Flat Fees": <FlatFeesContactTab contactID={contactId} />,
    // Items: <ItemsTab />,
    Files: <ContactFiles contactId={contactId} />,
    Reminders: <RemindersTab parentType="contact" parentId={contactId} />,
    "Document Signature": <ContactDocumentSignature contactData={contactData} contactId={contactId} />,
  };
  const DEFAULT_TAB = profileTabs[0].text;
  const initialTab = searchParams.get("tab") || DEFAULT_TAB;
  const [activeTab, setActiveTab] = useState(initialTab);
  // const [activeTab, setActiveTab] = useState(profileTabs[0].text);

  const getSingleContact = async (contactId) => {
    setDataLoading(true)
    try {
      const { data, status } = await contactService.getSingleContact(contactId);
      if (status) {
        setContactData(data)
      }
    } catch (error) {
      console.error('Error', error)
      toast.error('Failed to fetch Contact.', {
        description: 'An error occurred while fetching contact. Please try again later.',

      });
    } finally {
      setDataLoading(false)
    }
  }

  useEffect(() => {
    getSingleContact(contactId)
  }, [])

  const handleEdit = (contact_id) => {
    navigate(`/contacts/edit/${contact_id}/`, {
      state: {
        from: `/contacts/${contact_id}`,
        contact_id: contact_id,
      },
    })
  }

  const handleDelete = async () => {
    closeModal();
    try {
      const { status } = await contactService.deleteContact(actionId);
      if (status) {
        navigate('/contacts')
        toast.success('Deleted Contact.', {
          description: 'Contact deleted Successfully.',

        });
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message === `Can't delete: Matter records are related to this Contact.`) {
        toast.error('Cannot delete Contact.', {
          description: error.message,
        });
        return
      }
      toast.error('Failed to delete Contact.', {
        description: 'An error occurred while deleting contact. Please try again later.',

      });
    }
  };

  const handleTabChange = (tabText) => {
    setActiveTab(tabText);

    const url = new URL(window.location.href);
    url.searchParams.set("tab", tabText);
    window.history.replaceState({}, "", url);
  };


  useEffect(() => {
    fetchContactPaymentHistory()
    if (canViewActivity) { getActivities(); }
  }, [])

  useEffect(() => {
    // Sync tab with URL when user refreshes or navigates back
    const currentTab = searchParams.get("tab");
    if (currentTab && profileTabs.some(t => t.text === currentTab)) {
      setActiveTab(currentTab);
    } else {
      setActiveTab(DEFAULT_TAB);
    }
  }, [searchParams]);

  return (
    <>
      <GeneralProfileHero
        data={contactData}
        isLoading={dataLoading}
      />

      {/* The contact's name and tabs stay on screen while the page scrolls (OL-226). */}
      <StickyDetailBar title={contactData?.fullName || contactData?.name}>
      <Container className="h-fit grow-0">
        <Navbar customClass="!items-start">
          <div className='scrollable-x-auto pb-4 flex flex-wrap items-start gap-2'>
            {profileTabs.map((tab, index) => (
              <button
                key={tab.text}
                className={`btn btn-sm ${activeTab === tab.text ? "btn-primary" : "btn-light"
                  } `}
                // ${tab.comingSoon ? "cursor-not-allowed opacity-50" : ""}
                // onClick={() => { if (!tab.comingSoon) setActiveTab(tab.text); }}
                onClick={() => { if (!tab.comingSoon) handleTabChange(tab.text); }}
                disabled={tab.comingSoon || !tab.disabled}
              >
                <KeenIcon icon={tab.icon} />
                {tab.label ?? tab.text}
                {/* {tab.comingSoon && ( <span className='badge badge-pill badge-xs badge-outline badge-success text-4xs'>Coming Soon</span> )} */}
              </button>
            ))}
          </div>

          <NavbarActions>
            <ContactDetailsMenu onEdit={() => { handleEdit(contactId) }} onDelete={() => { openModal(contactId) }} />
          </NavbarActions>
        </Navbar>
      </Container>
      </StickyDetailBar>

      <Container>
        {!billingHidden && (
          <ContactMatterBillingSummary paymentData={contactPaymentHistory} loading={paymentHistoryLoading} />
        )}
        <AilaSummaryPanel parentType="contact" parentId={contactId} />
        {tabComponents[activeTab]}

        <ConfirmationModal
          show={isOpen}
          onClose={closeModal}
          onConfirm={handleDelete}
          message="Are you sure you want to delete this contact? You can restore it from the Recycle Bin within 30 days."
          title="Are You Sure?"
        />
        {/* for user activity */}
        <Can I="view" a="activity" ability={ability}>
          <ActivityTab activityData={activityData} />
        </Can>
      </Container>
    </>
  )
};
export { ContactsDetail };